
export const DEFAULT_FLAG_CODE = 'us'

export const emailLanguageCodes = [
    { label: 'German', code: 'de' },
    { label: 'Swiss', code: 'ch' },
    { label: 'English', code: 'gb' },
    { label: 'French', code: 'fr' },
    { label: 'Spanish', code: 'es' },
    { label: 'Turkish', code: 'tr' },
    { label: 'Chinese', code: 'cn' },
    { label: 'Japanese', code: 'jp' }
];

export const languageNames = {
    en: "English",
    fr: "French",
    de: "German",
    es: "Spanish",
    it: "Italian",
    zh: "Chinese",
    ja: "Japanese",
    ru: "Russian",
};